import Image from 'next/image';

import { joinSgcmMedia } from '@/utils/url/join/public';

import styles from './styles.module.scss';
import type { Component } from './types';

export const NoCurrentPromo: Component = ({ handleAddToShortlist }) => (
  <div className={styles.noCurrentContainer}>
    <div>
      <Image
        alt="No current promotions"
        height={144}
        src={`${joinSgcmMedia('/public/new-cars/no-search-results.svg')}`}
        width={164} />
      <div className={styles.textNoPromo}>
        No current promotions
      </div>
      <div className={styles.textAlertMeContainer}>
        <button
          className={styles.btnAlertMe}
          onClick={handleAddToShortlist}>
          Alert me
        </button>
        <div>&nbsp;when new promotion are inserted</div>
      </div>
    </div>
  </div>
);
